<template>
  <div class="_app">
    <NuxtPage />
    <!-- 确认按钮弹出框-授权 -->
    <AuthConfirmDialog />

    <!-- 登录后才显示 -->
    <template v-if="loginStore.isLogin && isHydrated">
      <!-- webView -->
      <WebViewPopup />
      <!-- 主动拨打电话等待中 -->
      <!-- <CallWaitingPopup /> -->
      <!-- 电话接听 -->
      <!-- <CallAcceptPopup /> -->
      <!-- 用户信息弹窗 -->
      <UserInfoPopup />
    </template>
  </div>
</template>

<script setup lang="ts">
import '@vant/touch-emulator' // 桌面端适配,将 mouse 事件转换成对应的 touch 事件

const publicStore = usePublicStore()

const loginStore = useLoginStore()
const callStore = useCallStore()
const { isHydrated } = useHydrated()
// 语言初始化
const languageStore = useLanguageStore()
languageStore.initLanguage()

const route = useRoute()

// 路由监听，同步当前路径
watch(
  () => route.path,
  (path) => {
    publicStore.setCurrentPath(path)
  },
  { immediate: true }
)

// 浏览器  client端才会走的逻辑
if (process.client) {
  // 初始化登录
  if (route.path.indexOf('/roomApp/') !== -1 && common.checkVersion().app) {
    // 在客户端打开房，逻辑性逻辑在内嵌房间使用
  }
}
</script>

<style></style>
